import FieldReferenceIdAndKeyDto from "../../../dtos/FieldReferenceIdAndKeyDto";
import PathSynchroMappingCapabilitiesDto from "../../../dtos/pathsynchromodule/PathSynchroMappingCapabilitiesDto";
import TransformationCapabilitiesDto from "../../../dtos/transformationmodule/TransformationCapabilitiesDto";

class GetPathSynchroCapabilitiesResult {
    SourceFields: FieldReferenceIdAndKeyDto[];
    TargetFields: FieldReferenceIdAndKeyDto[];
    MappingsCapabilities: PathSynchroMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[]; 
    AutoMappingResult: string | null;

    constructor(sourceFields: FieldReferenceIdAndKeyDto[], targetFields: FieldReferenceIdAndKeyDto[], mappingsCapabilities: PathSynchroMappingCapabilitiesDto[], transformationCapabilities: TransformationCapabilitiesDto[], autoMappingResult: string | null) {
        this.SourceFields = sourceFields;
        this.TargetFields = targetFields;
        this.MappingsCapabilities = mappingsCapabilities;
        this.TransformationsCapabilities = transformationCapabilities;
        this.AutoMappingResult = autoMappingResult;
    }
}

export default GetPathSynchroCapabilitiesResult;
